import LayerIcon from "../../assets/icons/layers.svg";
import PlusIcon from "../../assets/images/Plus.svg";
import ReloadIcon from "../../assets/icons/Reload.svg";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import { AdvicedItemPurchaseData, generateAdvicedPurchaseOrder } from "../../redux/actions/action";

import "../../assets/styles/local/Stock.css";

const AdvisedItemPurchaseCard = (props) => {
  const dispatch = useDispatch();

  const history = useHistory();
  const [advicedPurchaseData, setAdvicedPurchaseData] = useState([]);
  const puchasingAdviceData = useSelector((state) => state.user.advicedItemPurchase);

  useEffect(() => {
    if (puchasingAdviceData != null) {
      if (puchasingAdviceData?.status && puchasingAdviceData?.data) {
        setAdvicedPurchaseData(puchasingAdviceData.data);
      }
    }
  }, [puchasingAdviceData]);

  const formatNumber = (number) => {
    return number ? number.toFixed(0).replace(/\d(?=(\d{3})+$)/g, "$&,") : 0;
  };

  const RedirectToPuchaseOrderPage = () => {
    history.push({
      pathname: "/advance-item-purchasing",
    });
  };

  const GenerateAdvisedPurchaseOrder = () => {
    generateAdvicedPurchaseOrder().then((o) => {
      history.push({
        pathname: "/advance-item-purchasing",
      });
    });
  };

  const packageId = window.localStorage.getItem("packageId");

  useEffect(() => {
    dispatch(AdvicedItemPurchaseData());
  }, []);

  return (
    <>
      <div
        // className="total-stock sub-stock minheight-42-vh mt-4"
        className={
          packageId === process.env.REACT_APP_IS_PLUS
            ? "d-none"
            : "total-stock sub-stock minheight-42-vh mt-4"
        }
      >
        <div className="stock-title">
          <div className="d-flex justify-content-end totalStock-img">
            <img src={LayerIcon} className="stock-card-products-img" alt="totalStock" />
          </div>
          <p className="stock-title-main">{"Advised Item Purchasing"}</p>
          {advicedPurchaseData.length > 0 && props.showActions && (
            <div className="d-flex totalStock-img">
              <img
                onClick={() => RedirectToPuchaseOrderPage()}
                src={PlusIcon}
                className="card-plus-img me-2"
                alt="totalStock"
              />
              <img
                onClick={() => GenerateAdvisedPurchaseOrder()}
                src={ReloadIcon}
                className="card-plus-img"
                alt="totalStock"
              />
            </div>
          )}
        </div>
        <div className="sub-items">
          {advicedPurchaseData.length > 0 && (
            <div className="row height-2vh ">
              <div className="col-7">
                <p className="adv-order-purchase-title">Item</p>
              </div>
              <div className="col-5 text-end">
                <p className="adv-order-purchase-title">Purchase Qty</p>
              </div>
            </div>
          )}

          {advicedPurchaseData.map((item) => (
            <div className="row height-2vh ">
              <div className="col-7">
                <p className="adv-order-purchase-item">{item.partname}</p>
              </div>
              <div className="col-5 text-end">
                <p className="adv-order-purchase-item">{formatNumber(item.purchaseQty)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AdvisedItemPurchaseCard;
